// ============================================
// NOTIFICATION POPUP COMPONENT
// Full-screen popup for Bar/Kitchen ready orders
// Extracted from POSPageV2.jsx
// ============================================

import React, { useEffect } from 'react';
import { Bell, CheckCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

const NotificationPopup = ({ notification, onClose, onServed }) => {
    // Auto-close après 15 secondes
    useEffect(() => {
        if (!notification) return;
        
        const timer = setTimeout(() => {
            onClose();
        }, 15000);
        return () => clearTimeout(timer);
    }, [notification, onClose]);
    
    if (!notification) return null;
    
    const isBar = notification.type === 'bar';
    const bgColor = isBar ? 'bg-purple-600' : 'bg-orange-600';
    const headerColor = isBar ? 'bg-purple-700' : 'bg-orange-700';
    const icon = isBar ? '🍹' : '🍽️';
    const title = isBar ? 'BAR' : 'CUISINE';
    
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 animate-in fade-in duration-200">
            <div className={cn(
                "rounded-2xl shadow-2xl overflow-hidden max-w-md w-full mx-4 animate-in zoom-in-95 duration-300",
                bgColor
            )}>
                {/* Header avec animation */}
                <div className={cn("px-6 py-4 flex items-center justify-between", headerColor)}>
                    <div className="flex items-center gap-3">
                        <span className="text-4xl animate-bounce">{icon}</span>
                        <div>
                            <h2 className="text-2xl font-black text-white">{title}</h2>
                            <p className="text-white/80 text-sm">Commande prête !</p>
                        </div>
                    </div>
                    <Bell className="h-8 w-8 text-white animate-pulse" />
                </div>
                
                {/* Contenu */}
                <div className="p-6 text-white">
                    <div className="text-center mb-6">
                        <div className="text-6xl font-black mb-2">
                            Table {notification.tableNumber}
                        </div>
                        <div className="text-xl opacity-80">
                            Commande #{notification.orderNumber}
                        </div>
                    </div>
                    
                    {/* Boutons d'action */}
                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 bg-white/20 hover:bg-white/30 text-white px-6 py-4 rounded-xl font-bold text-lg transition-colors"
                        >
                            Plus tard
                        </button>
                        <button
                            onClick={() => {
                                if (notification.orderId) {
                                    onServed(notification.orderId);
                                }
                                onClose();
                            }}
                            className="flex-1 bg-white text-gray-800 px-6 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-colors flex items-center justify-center gap-2"
                        >
                            <CheckCircle className="h-6 w-6" />
                            Servi !
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;
